import React, { useRef, useEffect } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import Calendar from '../listing-calendar'

const SecondaryListingDatePicker = ({
  primaryListingDate,
  secondaryListingDate,
  setSecondaryListingDate,
  showCalendar2,
  setShowCalendar2,
  secondaryListingDateError,
  setSecondaryListingDateError,
  reservedDates = [],
  onRemove,
}) => {
  const containerRef = useRef(null);

  const handleDateClick = () => setShowCalendar2((s) => !s);

  const handleDateSelect = (iso) => {
    if (!primaryListingDate) {
      setSecondaryListingDateError('Please choose Primary Listing Date first.');
      setShowCalendar2(true);
      return;
    }
    if (iso <= primaryListingDate) {
      setSecondaryListingDateError('Secondary Listing Date must be after Primary Listing Date.');
      setShowCalendar2(true);
      return;
    }
    setSecondaryListingDate(iso);
    setSecondaryListingDateError('');
    setShowCalendar2(false);
  };

  useEffect(() => {
    if (!showCalendar2) return;

    const onPointerDown = (ev) => {
      // If click/touch is outside the container, close the calendar
      if (containerRef.current && !containerRef.current.contains(ev.target)) {
        setShowCalendar2(false);
      }
    };

    const onKeyDown = (ev) => {
      if (ev.key === 'Escape') {
        setShowCalendar2(false);
      }
    };

    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('touchstart', onPointerDown);
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('touchstart', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [showCalendar2, setShowCalendar2]);

  return (
    <Form.Group controlId="reservationsecondaryListingDate" className="mb-3 position-relative">
      <Form.Label>Secondary Listing Date</Form.Label>
      <Row className="g-2">
        <Col>
          <div className="position-relative" ref={containerRef}>
            <div className="d-flex">
              <Form.Control
                type="text"
                value={secondaryListingDate}
                placeholder="Select a date"
                readOnly
                onClick={handleDateClick}
                aria-label="Second reservation date"
                isInvalid={!!secondaryListingDateError}
              />
              <Button
                variant="primary"
                size="sm"
                onClick={handleDateClick}
                type="button"
                aria-label="Pick second date"
              >
                <FontAwesomeIcon icon={faCalendar} />
              </Button>
            </div>

            {showCalendar2 && (
              <div className="calendarWrapperStyle position-absolute mt-2" style={{ zIndex: 1060, left: 0 }}>
                <Calendar
                  onDateSelect={handleDateSelect}
                  reservedDates={reservedDates}
                  minSelectableDate={primaryListingDate}
                  initialVisibleDate={primaryListingDate ? new Date(primaryListingDate) : undefined}
                />
              </div>
            )}
          </div>
        </Col>
      </Row>

      {secondaryListingDateError && <Form.Text className="text-danger d-block mt-1">{secondaryListingDateError}</Form.Text>}
    </Form.Group>
  );
}

export default SecondaryListingDatePicker;
